import { render, staticRenderFns } from "./SubscriptionTag.vue?vue&type=template&id=00315e98&scoped=true&lang=pug"
import script from "./SubscriptionTag.vue?vue&type=script&lang=js"
export * from "./SubscriptionTag.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionTag.vue?vue&type=style&index=0&id=00315e98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00315e98",
  null
  
)

export default component.exports